<template>
<div class=searchBarFilter>
  <v-text-field :loading="loading" :disabled="loading" @change="setSearchBarText()"
    v-model="textSearchStoryTitle" :aria-label="$t('searchStory')" :label="$t('searchStory')" single-line clearable
   @click:clear="clearTextSearchStoryTitle" :placeholder="$t('searchStory')" prepend-inner-icon="mdi-magnify"
    minlength="250px" class='mt-3' dense></v-text-field>
</div>
</template>
<script>
//import { mapState } from 'vuex';
export default ({
  name: 'searchBarFilter',

  data: () => ({
    textSearchStoryTitle:""
  }),
  computed: {
    userHasSkippedFilterTag: function(){
        return this.$store.state.userHasSkippedFilterTag;
    },
    loading: function(){
        return this.$store.getters.getLoading;
    }
  },
  mounted:  function () {
  },

  methods: {
    setSearchBarText() {
      if (this.textSearchStoryTitle==null){
      this.textSearchStoryTitle=""
      }
        this.$store.dispatch('setSearchBarTextValue',this.textSearchStoryTitle)
    },
    clearTextSearchStoryTitle(){
        this.textSearchStoryTitle = ""
        this.$store.dispatch('setSearchBarTextValue',this.textSearchStoryTitle)

    }
  }
})
</script>


<style>


.v-text-field input{
  min-width: 180px;
}

.searchBarFilter .theme--light.v-text-field > .v-input__control > .v-input__slot:before,
.searchBarFilter .theme--light.v-text-field > .v-input__control > .v-input__slot::after {
    border-color: transparent !important;
}
/*
.searchBarFilter div.v-input.expanding-search{
  transition: max-width 0.5s;
}
.searchBarFilter div.v-input.expanding-search.mt-3.closed{
max-width: 1rem;
}
*/

</style>